export function selectText(elem: HTMLInputElement) {
    setTimeout(() => { elem.focus(); elem.setSelectionRange(0, elem.value.length); }, 0);
}

export function setCaretAtEnd(element: HTMLInputElement) {
    let elemLen = element.value.length;
    // For IE Only
    if ((document as any).selection) {
        // Set focus
        element.focus();
        // Use IE Ranges
        var oSel = (document as any).selection.createRange();
        // Reset position to 0 & then set at end
        oSel.moveStart('character', -elemLen);
        oSel.moveStart('character', elemLen);
        oSel.moveEnd('character', 0);
        oSel.select();
    }
    else if (element.selectionStart || element.selectionStart === 0) {
        // Firefox/Chrome
        element.selectionStart = elemLen;
        element.selectionEnd = elemLen;
        element.focus();
    }
}